import { IUIStore, useUIStore } from "./Store.ts";
import { Toast as BootstrapToast } from "bootstrap";
import { produce } from "immer";
import { useEffect, useRef } from "react";

function toastId(t: string): string {
  return `toast-${t.toLowerCase().replaceAll(new RegExp("[^a-z]", "g"), "")}`;
}

function removeToast(toast: string) {
  useUIStore.setState(
    produce((s: IUIStore) => {
      s.toasts = s.toasts.filter((t) => t !== toast);
    }),
  );
}

const Toast = ({ toast }: { toast: string }) => {
  const toastRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const toastElement = toastRef.current;
    if (toastElement !== null) {
      const toastBootstrap = BootstrapToast.getOrCreateInstance(toastElement);
      toastBootstrap.show();
      const handler = () => {
        removeToast(toast);
      };
      toastElement.addEventListener("hidden.bs.toast", handler);

      return () => {
        toastElement.removeEventListener("hidden.bs.toast", handler);
      };
    }
  }, [toast, toastRef]);
  return (
    <div
      id={toastId(toast)}
      data-testid={toastId(toast)}
      className="toast align-items-center"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      ref={toastRef}
    >
      <div className="d-flex">
        <div className="toast-body">{toast}</div>
        <button
          id={`${toastId(toast)}-close`}
          data-testid={`${toastId(toast)}-close`}
          type="button"
          className="btn-close me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        />
      </div>
    </div>
  );
};

export default Toast;
